export enum ConfigType {
    Catering = 'cateringList',
    Distribution = 'distributionList',
    SeqNumber = 'snippetSeqNumber',
    Country = 'country',
    Company = 'company',
    OrgUnit = 'orgunit',
    DocInit = 'docInitData'
}
